import './ImportAnnotationsButton.scss';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EnableFor } from '../../../../../../../__legacy__/containers/EnableForRole';
import { useProjectDetailsPermissions } from '../../../../../../../__legacy__/modules/projectDetails/projectDetails.permissions';
import { IProjectDetailsStore } from '../../../../../../../__legacy__/modules/projectDetails/projectDetails.store';
import { ProjectStatus } from '../../../../../../../__legacy__/modules/projects/projects.model';

interface IProps {
  onStartImport: () => void;
}

export const ImportAnnotationsButton = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const permissions = useProjectDetailsPermissions();
  const projectDetails = useInjection(IProjectDetailsStore.$);
  return (
    <>
      {projectDetails.status !== ProjectStatus.Draft && (
        <EnableFor hasPermission={permissions.canImportAnnotations()}>
          <Button
            onClick={props.onStartImport}
            className='import-annotations-button'
          >
            {t('new.projects.details.import_annotations.header')}
          </Button>
        </EnableFor>
      )}
    </>
  );
});
